<template>
	<div v-if="show" class="md-theme-default">
		<h4 class="mobile-subtitle-2">{{ title }}</h4>
		<workflow-list-item
			v-for="(wf, index) in renderedWorkflows"
			:workflow="wf"
			:key="index"
			@workflow-click="workflowClick"
		/>
	</div>
</template>

<script>
import WorkflowListItem from '@/components/myWorkflows/WorkflowListItem.vue';
import {mapGetters, mapState} from 'vuex';
import {validateEntryPoints} from '@/util/validateEntryPoints.js';
import {trackEvent} from '@/services/tracking.js';

export default {
	name: 'wfc-workflows',
	components: {WorkflowListItem},
	props: {
		contextId: {type: String, default: ''},
		limit: {type: Number, default: 10},
	},
	computed: {
		...mapState({
			workflowNamesDict: (state) => state.workflowNamesDict,
		}),
		...mapGetters(['getStepNames', 'entryPoints']),
		...mapGetters({
			getWorkflowsByContextId: 'RecommendedWorkflows/getWorkflowsByContextId',
			getWorkflowsTitleByContextId: 'RecommendedWorkflows/getWorkflowsTitleByContextId',
		}),
		title() {
			return this.getWorkflowsTitleByContextId(this.contextId);
		},
		renderedWorkflows() {
			const workflowStrings = this.getWorkflowsByContextId(this.contextId);

			if (workflowStrings && this.entryPoints) {
				return workflowStrings
					.map(this.parseWorkflowString)
					.map(this.createWorkflowItem)
					.filter((w) => w)
					.slice(0, this.limit);
			}
		},
		show() {
			return !!this.renderedWorkflows?.length;
		},
	},
	async created() {
		await this.$store.dispatch('RecommendedWorkflows/fetchRecommendedWorkflowsConfiguration');
	},
	methods: {
		parseWorkflowString(workflowString) {
			let wfParsed = workflowString?.split('/');
			if (!(wfParsed && wfParsed.length === 4)) {
				console.error(`Invalid workflow string: "${workflowString}"`);
				return null;
			}

			let wf = {
				application: wfParsed[0],
				startingMaterial: wfParsed[1],
				analyte: wfParsed[2],
				analysisType: wfParsed[3],
			};

			if (!validateEntryPoints(wfParsed, this.entryPoints)) {
				console.error('Invalid Entrypoints', workflowString);
				return null;
			}

			if (!wf.application || !wf.startingMaterial || !wf.analyte || !wf.analyte) {
				console.error(`Invalid Workflow String : ${workflowString}`);
				return null;
			}
			return wf;
		},

		createWorkflowItem(wf) {
			if (!wf.application || !wf.startingMaterial || !wf.analyte || !wf.analyte) {
				console.error(`Invalid Workflow String : ${wf}`);
				return null;
			}

			let workflow = this.getWorkflow(wf);
			if (!workflow) {
				console.error('No Workflow for wf ', wf);
				return null;
			}

			return {
				title: this.getWorkflowName(wf),
				steps: this.getWorkflowSteps(workflow),
				url: `${wf.application}/${wf.startingMaterial}/${wf.analyte}/${wf.analysisType}`,
			};
		},

		getWorkflow(wf) {
			return this.$store.state.hcube.workflows[this.getWorkflowKey(wf)];
		},

		getWorkflowKey(wf) {
			return `${this.entryPoints.indexOf(wf.application)}.${this.entryPoints.indexOf(
				wf.startingMaterial,
			)}.${this.entryPoints.indexOf(wf.analyte)}.${this.entryPoints.indexOf(wf.analysisType)}`;
		},

		getWorkflowName(wf) {
			const ap = this.workflowNamesDict[wf.application] || wf.application;
			const sm = this.workflowNamesDict[wf.startingMaterial] || wf.startingMaterial;
			const an = this.workflowNamesDict[wf.analyte] || wf.analyte;
			const at = this.workflowNamesDict[wf.analysisType] || wf.analysisType;
			return `${ap} - ${sm} - ${an} - ${at}`;
		},
		getWorkflowSteps(workflow) {
			return this.getStepNames(workflow.steps)
				.sort((a, b) => a.index - b.index)
				.map((step) => step.name);
		},
		workflowClick(workflowUrl) {
			trackEvent('ctaClick', {eVar58: 'Show Workflow | Recomended Workflows'});
			window.location.assign(workflowUrl);
		},
	},
};
</script>

<style lang="scss">
.mobile-subtitle-2 {
	margin-top: 10px;
	margin-bottom: 10px;
}
</style>
